import * as React from 'react';
import { SecondaryButton, PrimaryButton } from './Button';
import { Markup } from 'interweave';
import { SecondaryTitle } from './Title';
import * as styleSheet from '../styles';
import { Box } from '@enaep-ng/benchmark';
import { WarningProps } from '../types';

export default function Warning({ className, style, ...props }: WarningProps) {
  const renderButtons = () => {
    if (!props.buttons) {
      return null;
    }

    return (
      <Box>
        {props.buttons.map((buttonElem) =>
          buttonElem.variant === 'primary' ? (
            <PrimaryButton
              label={buttonElem.label}
              action={buttonElem.action}
            />
          ) : (
            <SecondaryButton
              label={buttonElem.label}
              action={buttonElem.action}
            />
          )
        )}
      </Box>
    );
  };

  return (
    <Box style={styleSheet.warningContainer} className={className} sx={style}>
      {props.title && (
        <Box style={styleSheet.warningErrorHeader} direction="horizontal">
          <SecondaryTitle content={props.title} />
        </Box>
      )}
      <Box style={styleSheet.warningErrorBody} className="d-flex d-grid">
        {props.errorCode && (
          <div style={styleSheet.warningErrorCodeStyle}>
            <Markup content={props.errorCode} />
          </div>
        )}
        {props.message && <Markup content={props.message} />}
      </Box>
      <Box sx={{display: 'flex', justifyContent: 'center'}}>
        {renderButtons()}
      </Box>
    </Box>
  );
}
